<template>
  <div class="fagj-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="未完成" :value="1"/>
                <el-option label="已完成" :value="9"/>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-table
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              @row-click="openDetails"
              v-loading="loading"
              style="width: 100%">
              <el-table-column
                label="房屋标识"
                min-width="180"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="color:#000;">{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户名称"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.custname}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="联系电话"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.tel}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="地区"
                width="150"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.province}} {{scope.row.city}} {{scope.row.county}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="详细地址"
                width="180"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="设计师"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.designer_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客服"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.customer_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="销售内勤"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.sales_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="项目经理"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.foreman_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="计划开工日期"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.starttime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="计划完工日期"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.endtime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="当前阶段"
                width="120"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.mark!==9"> {{scope.row.stage}}</span>
                  <span v-if="scope.row.mark===9"> 已验收</span>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                width="120"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="danger">未完成</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9">已完成</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDelDecorationList } from '@/api/dealer'

export default {
  name: 'fagj',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: '',
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search != null && this.searchForm.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: 1,
        search: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        userid: this.user.userid,
        mark: this.searchForm.type
      }
      getDelDecorationList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/deldecoration/' + row.did })
    }
  }
}
</script>

<style lang="scss" scoped>
.fagj-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
